// extracted by mini-css-extract-plugin
module.exports = {"customSelect":"select_customSelect__Fe0u_","wrapperFlags":"select_wrapperFlags__nfs6j","iconWidth":"select_iconWidth__6Bk06"};